import React, { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router';

import Loadable from '../layouts/full/shared/loadable/Loadable';
import BonusesDash from '../views/groups/bonuses/BonusesDash';
import FSList from '../views/groups/freespin/FSList';
import FSInfo from '../views/groups/freespin/FSInfo';
import PostbackLink from '../views/groups/affiliate_links/postbacks/PostbackLink';
import ReferralLink from '../views/groups/affiliate_links/referral/ReferralLink';
import SliderListBanners from '../views/groups/slider_banners/ListBanners.jsx';
import EditBanner from '../views/groups/slider_banners/EditBanner.jsx';
import CreateCasinos from '../views/settings/casino/create/CreateCasinos.jsx';
import SettingsCasinos from '../views/settings/casino/SettingsCasinos.jsx';
import SettingGameBonus from '../views/settings/games/bonus/SettingGameBonus.jsx';
import SettingGameProvider from '../views/settings/games/providers/SettingGameProvider.jsx';
import CasinoNames from '../views/settings/casino/common/names/CasinoNames.jsx';
import CasinoCurrencies from '../views/settings/casino/common/currencies/CasinoCurrencies.jsx';
import CasinoDomains from '../views/settings/casino/common/domains/CasinoDomains.jsx';
import PaymentProviders from '../views/settings/casino/payment/payment_providers/PaymentProviders.jsx';
import DepositPlayers from '../views/finance/deposits/DepositPlayers.jsx';
import PaymentGateway from '../views/settings/casino/payment/gateway/PaymentGateway.jsx';
import PaymentPlayers from '../views/finance/payments/PaymentPlayers.jsx';
import UsersLogs from '../views/users/journal/UsersLogs.jsx';
import CasinoAgreement from '../views/settings/casino/common/agreement/CasinoAgreement.jsx';
import PaymentDeposits from '../views/settings/casino/payment/deposits/PaymentDeposits.jsx';
import PaymentWithdrawal from '../views/settings/casino/payment/withdrawal/PaymentWithdrawal.jsx';
import LangLinks from '../views/settings/casino/lang_links/LangLinks.jsx';
import SettingsBanner from '../views/settings/casino/design/banners/SettingsBanner.jsx';
import ManagerTgNotify from '../views/settings/casino/tg-notify/managers/ManagerTgNotify.jsx';
import PlayersTgNotify from '../views/settings/casino/tg-notify/players/PlayersTgNotify.jsx';
import CasinoLogo from '../views/settings/casino/design/logo/CasinoLogo.jsx';
import TgCasino from '../views/settings/casino/tg-casino/TgCasino.jsx';
import PaymentCascade from '../views/settings/casino/payment/cascade/PaymentCascade.jsx';
import CasinoColor from '../views/settings/casino/design/color/CasinoColor.jsx';
import CasinoInsertHead from '../views/settings/casino/design/insert_head/CasinoInsertHead.jsx';
import CasinoInsertBody from '../views/settings/casino/design/insert_body/CasinoInsertBody.jsx';
import CasinoChatTawk from '../views/settings/casino/design/chat_tawk/CasinoChatTawk.jsx';
import CasinoPlayersOnline from '../views/settings/casino/design/online_players/CasinoPlayersOnline.jsx';
import CasinoCaptchaSetting from '../views/settings/casino/captcha/CasinoCaptchaSetting.jsx';
import BalanceGateway from '../views/finance/balance_gateway/BalanceGateway.jsx';
import UserIpAddress from '../views/users/ip_adsress/UserIpAddress.jsx';
import FinanceProfile from '../views/users/finance_profile/FinanceProfile.jsx';
import UsersList from '../views/users/users/UsersList.jsx';
import HistoryMailing from '../views/mailing/history_mailing/HistoryMailing.jsx';
import SettingGameStatistic from '../views/reports/games/SettingGameStatistic.jsx';
import ReportPlayers from '../views/reports/players/ReportPlayers.jsx';
import ReportBonuses from '../views/reports/bonuses/ReportBonuses.jsx';
import Scheduler from '../views/mailing/scheduler/Scheduler.jsx';
import CasinoAuth from '../views/settings/casino/common/auth/CasinoAuth.jsx';
import MailingItem from '../views/mailing/item/MailingItem.jsx';
import PaymentOther from '../views/settings/casino/payment/other/PaymentOther.jsx';
import ReportRefcode from '../views/reports/refcodes/ReportRefcode.jsx';
import AuthorizationSetting from '../views/settings/casino/authorization/CasinoMailingSettings.jsx';
import SettingAggregator from '../views/settings/aggregator/SettingAggregator.jsx';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));
const CasinoLayout = Loadable(lazy(() => import('../layouts/casino/CasinoLayout.jsx')));

/* ****Pages***** */
const ModernDash = Loadable(lazy(() => import('../views/dashboard/Modern')));
const GroupsDash = Loadable(lazy(() => import('../views/groups/Groups')));

const UserProfile = Loadable(lazy(() => import('../views/user-profile/UserProfile')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
// const Login2 = Loadable(lazy(() => import('../views/authentication/auth2/Login2')));
const Register = Loadable(lazy(() => import('../views/authentication/auth1/Register')));
// const Register2 = Loadable(lazy(() => import('../views/authentication/auth2/Register2')));
// const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth1/ForgotPassword')));
// const ForgotPassword2 = Loadable(
//   lazy(() => import('../views/authentication/auth2/ForgotPassword2'))
// );
// const TwoSteps = Loadable(lazy(() => import('../views/authentication/auth1/TwoSteps')));
// const TwoSteps2 = Loadable(lazy(() => import('../views/authentication/auth2/TwoSteps2')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));

const Router = [
  // {
  //   path: '/',
  //   element: <CasinoLayout />,
  //   children: []
  // },
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboards/modern', exact: true, element: <ModernDash /> },
      { path: '/dashboard', exact: true, element: <ModernDash /> },

      { path: '/groups/:groupId', exact: true, element: <GroupsDash /> },
      { path: '/groups', exact: true, element: <GroupsDash /> },
      { path: '/bonuses/:id/:groupId', exact: true, element: <BonusesDash /> },
      { path: '/freespin/:groupId/list', exact: true, element: <FSList /> },
      { path: '/freespin/:groupId/:freeSpinId', exact: true, element: <FSInfo /> },
      { path: '/affiliate/:groupId/postbacks', exact: true, element: <PostbackLink /> },
      { path: '/affiliate/:groupId/referral', exact: true, element: <ReferralLink /> },
      { path: '/slider-banners/:groupId/list', exact: true, element: <SliderListBanners /> },
      { path: '/slider-banners/:groupId/:bannerId', exact: true, element: <EditBanner /> },

      { path: '/user-profile', element: <UserProfile /> },

      { path: '/settings/casino/create', exact: true, element: <CreateCasinos /> },
      { path: '/settings/casino/:casinoId', exact: true, element: <SettingsCasinos /> },
      { path: '/settings/casino', exact: true, element: <SettingsCasinos /> },
      // { path: '/settings/games/bonus', exact: true, element: <SettingGameBonus /> },
      { path: '/settings/games/providers', exact: true, element: <SettingGameProvider /> },
      { path: '/settings/providers', exact: true, element: <SettingAggregator /> },

      { path: '/reports/games/statistic', exact: true, element: <SettingGameStatistic /> },
      { path: '/reports/players', exact: true, element: <ReportPlayers /> },
      { path: '/reports/bonuses', exact: true, element: <ReportBonuses /> },
      { path: '/reports/refcode/', exact: true, element: <ReportRefcode /> },

      { path: '/finance/players/deposits', element: <DepositPlayers /> },
      { path: '/finance/players/payments', element: <PaymentPlayers /> },
      { path: '/finance/balance/gateway', element: <BalanceGateway /> },

      { path: '/casino/common/names/:casinoId', element: <CasinoNames /> },
      { path: '/casino/common/domains/:casinoId', element: <CasinoDomains /> },
      { path: '/casino/common/auth/:casinoId', element: <CasinoAuth /> },
      { path: '/casino/common/agreement/:casinoId', element: <CasinoAgreement /> },
      { path: '/casino/payment/currencies/:casinoId', element: <CasinoCurrencies /> },
      { path: '/casino/payment/cascade/:casinoId', element: <PaymentCascade /> },
      { path: '/casino/payment/setting/:casinoId', element: <PaymentProviders /> },
      { path: '/casino/payment/gateway/:casinoId', element: <PaymentGateway /> },
      { path: '/casino/payment/deposits/:casinoId', element: <PaymentDeposits /> },
      { path: '/casino/payment/withdrawal/:casinoId', element: <PaymentWithdrawal /> },
      { path: '/casino/payment/other/:casinoId', exact: true, element: <PaymentOther /> },
      { path: '/casino/tg-casino/:casinoId', element: <TgCasino /> },
      { path: '/casino/mailing/players/:casinoId', element: <PlayersTgNotify /> },
      { path: '/casino/mailing/managers/:casinoId', element: <ManagerTgNotify /> },
      { path: '/casino/design/logo/:casinoId', element: <CasinoLogo /> },
      { path: '/casino/design/color/:casinoId', element: <CasinoColor /> },
      { path: '/casino/design/banners/:casinoId', element: <SettingsBanner /> },
      { path: '/casino/design/banners/:casinoId/:langCode', element: <SettingsBanner /> },
      { path: '/casino/design/head/:casinoId', element: <CasinoInsertHead /> },
      { path: '/casino/design/body/:casinoId', element: <CasinoInsertBody /> },
      { path: '/casino/design/tawk/:casinoId', element: <CasinoChatTawk /> },
      { path: '/casino/design/players/:casinoId', element: <CasinoPlayersOnline /> },
      { path: '/casino/lang-links/:casinoId', element: <LangLinks /> },
      { path: '/casino/captcha/:casinoId', element: <CasinoCaptchaSetting /> },
      { path: '/casino/authorization/:casinoId', element: <AuthorizationSetting /> },

      { path: '/users/list', element: <UsersList /> },
      { path: '/users/logs/:userId', element: <UsersLogs /> },
      { path: '/users/IpAddresses/:userId', element: <UserIpAddress /> },
      { path: '/users/finance/:userId/:currency', element: <FinanceProfile /> },

      { path: '/mailing/scheduler', element: <Scheduler /> },
      { path: '/mailing/history', element: <HistoryMailing /> },
      { path: '/mailing/:id', element: <MailingItem /> }

      // { path: '/pages/account-settings', element: <AccountSetting /> },
      // { path: '/pages/faq', element: <Faq /> },

      // { path: '*', element: <Navigate to="/auth/404" /> }
      // { path: '*', element:  <Error /> }
    ]
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/auth/404', element: <Error /> },
      { path: '/auth/login', element: <Login /> },
      // { path: '/auth/login2', element: <Login2 /> },
      { path: '/auth/register', element: <Register /> },
      // { path: '/auth/register2', element: <Register2 /> },
      // { path: '/auth/forgot-password', element: <ForgotPassword /> },
      // { path: '/auth/forgot-password2', element: <ForgotPassword2 /> },
      // { path: '/auth/two-steps', element: <TwoSteps /> },
      // { path: '/auth/two-steps2', element: <TwoSteps2 /> },
      // { path: '*', element: <Navigate to="/auth/404" /> }
      { path: '*', element: <Error /> }
    ]
  }
];

const router = createBrowserRouter(Router, { basename: '/' });

export default router;
